import { API_CALL } from 'actions/actionConstants'
import { FETCH_METASEARCH_DISCOUNT } from 'actions/apiActionConstants'
import type { AppAction } from 'actions/types/ActionTypes'
import {
  buildMetasearchDiscountRequestKey,
  hasMetasearchDiscountContext,
  isMetasearchDiscountEnabled,
} from 'lib/metasearch/metasearchDiscountContext'
import {
  resolveMetasearchDiscount,
  type ResolveMetasearchDiscountInput,
} from 'lib/metasearch/metasearchDiscountApi'
import { getGhaPriceMatchForProperty } from 'selectors/ghaPriceMatchSelectors'

export type FetchMetasearchDiscountInput = Partial<ResolveMetasearchDiscountInput>

export function fetchMetasearchDiscount(input: FetchMetasearchDiscountInput): AppAction {
  return (dispatch, getState) => {
    if (!isMetasearchDiscountEnabled() || !hasMetasearchDiscountContext(input)) {
      return
    }
    // Bedbank already prices a price-matched room to Google's price, so it gets no GHA discount.
    if (getGhaPriceMatchForProperty(getState(), input.propertyId)) {
      return
    }

    const requestKey = buildMetasearchDiscountRequestKey(input)
    const currentDiscountState = getState().marketing.metasearchDiscount

    if (
      currentDiscountState.requestKey === requestKey &&
      (currentDiscountState.fetching || currentDiscountState.discountAmount !== undefined)
    ) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_METASEARCH_DISCOUNT,
      request: () => resolveMetasearchDiscount(input),
      requestKey,
    })
  }
}
